import _ from 'lodash'

export const toggleElementInArray = <T>(array: T[], element: T): T[] =>
  _.xor(array, [element])
